export default `:host {
  display: contents;
}

.ids-module-nav {
  box-sizing: content-box;
  display: flex;
  flex-direction: row;
  height: 100%;
  align-items: stretch;
  z-index: var(--ids-z-index-100);
}
.ids-module-nav.display-mode-expanded {
  overflow: hidden;
}

ids-menu-item::part(menu-item) {
  color: var(--ids-module-nav-settings-menu-item-text-color);
}
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VSb290IjoiL2J1aWxkcy9pbmZvci1kZXNpZ24vZW50ZXJwcmlzZS13Yy9zcmMvY29tcG9uZW50cy9pZHMtbW9kdWxlLW5hdiIsInNvdXJjZXMiOlsiaWRzLW1vZHVsZS1uYXYuc2NzcyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFHQTtFQUNFOzs7QUFHRjtFQUNFO0VBQ0E7RUFDQTtFQUNBO0VBQ0E7RUFDQTs7QUFFQTtFQUNFOzs7QUFPSjtFQUNFIiwic291cmNlc0NvbnRlbnQiOlsiLy8gTW9kdWxlIE5hdiBDb21wb25lbnRcbi8vID09PT09PT09PT09PT09PT09PT09PT09PT09PT09PT09PT09PT09PT09PT09PT09PT09IC8vXG5cbjpob3N0IHtcbiAgZGlzcGxheTogY29udGVudHM7XG59XG5cbi5pZHMtbW9kdWxlLW5hdiB7XG4gIGJveC1zaXppbmc6IGNvbnRlbnQtYm94O1xuICBkaXNwbGF5OiBmbGV4O1xuICBmbGV4LWRpcmVjdGlvbjogcm93O1xuICBoZWlnaHQ6IDEwMCU7XG4gIGFsaWduLWl0ZW1zOiBzdHJldGNoO1xuICB6LWluZGV4OiB2YXIoLS1pZHMtei1pbmRleC0xMDApO1xuXG4gICYuZGlzcGxheS1tb2RlLWV4cGFuZGVkIHtcbiAgICBvdmVyZmxvdzogaGlkZGVuO1xuICB9XG59XG5cbi8vIFN1Yi1jb21wb25lbnRzXG4vLyA9PT09PT09PT09PT09PT09PT09PT09PT09PT09PT09PT09PT09PT09PT09PT09PT09PSAvL1xuXG5pZHMtbWVudS1pdGVtOjpwYXJ0KG1lbnUtaXRlbSkge1xuICBjb2xvcjogdmFyKC0taWRzLW1vZHVsZS1uYXYtc2V0dGluZ3MtbWVudS1pdGVtLXRleHQtY29sb3IpO1xufVxuIl19 */`;
